import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localize } from '../../i18n/locale';

const Intro = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const tr = (ko, en) => localize(i18n.resolvedLanguage || i18n.language, { ko, en });

    return (
        <div className="intro-container">
            <div className="intro-card">
                <div className="icon-wrapper">
                    <span className="icon">🧠</span>
                </div>
                <h1>{tr('행동경향 테스트', 'Behavior Tendency Test')}</h1>
                <p className="subtitle">Context Locked Behavior Analysis</p>

                <div className="description">
                    <p>
                        {tr('당신은 어떤 상황에서 어떻게 행동하시나요?', 'How do you act in different situations?')}<br />
                        {tr('30개의 질문을 통해 당신의', 'Thirty questions analyze your')} <br />
                        <strong>{tr('결정 방식, 성찰 깊이, 행동 패턴', 'decision style, reflection depth, and behavior patterns')}</strong><br />
                        정밀하게 분석해드립니다.
                    </p>
                </div>

                <div className="features">
                    <div className="feature-item">
                        <span className="check">✓</span>
                        <span>{tr('9가지 행동 지표 분석', 'Nine behavioral indicators')}</span>
                    </div>
                    <div className="feature-item">
                        <span className="check">✓</span>
                        <span>{tr('상황별 의사결정 패턴 파악', 'Context-based decision patterns')}</span>
                    </div>
                    <div className="feature-item">
                        <span className="check">✓</span>
                        <span>{tr('자기 인식과 타인 인식의 괴리 측정', 'Self-perception and external-perception gap')}</span>
                    </div>
                </div>

                <button className="start-btn" onClick={() => navigate('/character-test/q/1')}>
                    {tr('테스트 시작하기', 'Start Test')}
                </button>
            </div>

            <style jsx>{`
                .intro-container {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1rem;
                    background: #0f172a;
                    color: white;
                }

                .intro-card {
                    background: rgba(255, 255, 255, 0.05);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 24px;
                    padding: 3rem 2rem;
                    width: 100%;
                    max-width: 500px;
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0,0,0,0.3);
                }

                .icon-wrapper {
                    width: 80px;
                    height: 80px;
                    background: rgba(59, 130, 246, 0.1);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 1.5rem;
                }

                .icon {
                    font-size: 3rem;
                }

                h1 {
                    font-size: 2rem;
                    font-weight: 800;
                    margin-bottom: 0.5rem;
                    background: linear-gradient(to right, #fff, #94a3b8);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .subtitle {
                    color: #64748b;
                    font-size: 0.9rem;
                    letter-spacing: 1px;
                    margin-bottom: 2.5rem;
                    text-transform: uppercase;
                    font-weight: 600;
                }

                .description {
                    background: rgba(255, 255, 255, 0.03);
                    padding: 1.5rem;
                    border-radius: 16px;
                    margin-bottom: 2rem;
                }

                .description p {
                    color: #cbd5e1;
                    line-height: 1.8;
                    font-size: 1.05rem;
                    margin: 0;
                }

                .description strong {
                    color: #60a5fa;
                }

                .features {
                    display: flex;
                    flex-direction: column;
                    gap: 0.8rem;
                    margin-bottom: 3rem;
                    text-align: left;
                    padding: 0 1rem;
                }

                .feature-item {
                    display: flex;
                    align-items: center;
                    gap: 0.8rem;
                    color: #94a3b8;
                    font-size: 0.95rem;
                }

                .check {
                    color: #3b82f6;
                    font-weight: bold;
                }

                .start-btn {
                    width: 100%;
                    padding: 1.25rem;
                    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 1.1rem;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.2s;
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
                }

                .start-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.4);
                }
            `}</style>
        </div>
    );
};

export default Intro;
